module.exports = __webpack_public_path__ + "static/media/sample_bulk_consignment_data.9819d846.csv";